import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import DotDotDot from '../../../app/components/dotdotdot';
import { getContentText } from '../../../app/services/content-text';
import styles from './content-excerpt.scss';

const ContentExcerpt = ({ content, excerpt, lineCount, autoFit }) => (
  <div className={classNames(styles.container, 'post-excerpt')}>
    <DotDotDot clamp={autoFit ? 'parent' : lineCount} useExactLineHeight={true}>
      <div className={styles.content} data-hook="post-description">
        {excerpt ? excerpt : getContentText(content)}
      </div>
    </DotDotDot>
  </div>
);

ContentExcerpt.propTypes = {
  content: PropTypes.object,
  excerpt: PropTypes.string,
  lineCount: PropTypes.number.isRequired,
  autoFit: PropTypes.bool,
};

export default ContentExcerpt;
